
import { Vue, Component, Ref } from 'vue-property-decorator';
import { BrandService } from '@/services/brand_service';
import lazyInject from '@/di';
import AudioShopUpload from '@/views/account-management/components/AudioShopUpload.vue';
import moment from 'moment';
import { getCurrentTimeSecond } from '@/common/utils';

@Component({
  components: {
    AudioShopUpload,
  },
})
export default class RecordingDrawer extends Vue {
  visible = false;

  title = '录音列表';

  tabPane: any = '1';

  @lazyInject(BrandService)
  brandService!: BrandService;

  @Ref('audioShopUpload')
  audioShopUpload!: AudioShopUpload;

  labelCol = {
    span: 8,
  };

  wrapperCol = {
    span: 16,
  };

  labelAlign = 'right';

  labelWidth = '220px';

  autoComplete = 'off';

  barName = '';

  createTime: any = [];

  shopData: any = {};

  columns = [
    {
      title: '上传时间',
      dataIndex: 'start_time',
      key: 'start_time',
      align: 'center',
      width: 180,
    },
    {
      title: '录音时长',
      dataIndex: 'duration',
      key: 'duration',
      align: 'center',
      width: 100,
      customRender: (text: any) => {
        if (text) {
          return `${Math.floor(text)}秒`;
        }
        return '--';
      },
    },
    {
      title: '销售姓名',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
      width: 180,
    },
    {
      title: '推送状态',
      dataIndex: 'pushed',
      key: 'pushed',
      align: 'center',
      width: 180,
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
      width: 240,
    },
  ];


  statusList = [
    {
      label: '全部',
      value: '',
    },
    {
      label: '已推送',
      value: '1',
    },
    {
      label: '推送中',
      value: '2',
    },
    {
      label: '推送失败',
      value: '-1',
    },
  ];

  dataSource: any = [];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChangePage,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    onShowSizeChange: this.onShowSizeChange,
  };

  shopId = 0;

  form: any = {
    kaId: 0,
    page: 1,
    pageSize: 10,
    contact_time_start: '',
    contact_time_end: '',
    username: '',
    pushed: '',
  };

  onChangePage(page: any) {
    this.pagination.current = page;
    this.form.page = page;
    this.getAudioList(this.form);
  }
  onShowSizeChange(current: number, size: number) {
    this.pagination.current = current;
    this.pagination.pageSize = size;
    this.form.page = current;
    this.form.pageSize = size;
    this.getAudioList(this.form);
  }
  onChange(val: any) {
    if (!val.length) {
      this.form.contact_time_start = null;
      this.form.contact_time_end = null;
      return;
    }
    this.createTime = val;
    this.$set(
      this.form,
      'contact_time_start',
      moment(val[0]).format('YYYY-MM-DD'),
    );
    this.$set(
      this.form,
      'contact_time_end',
      moment(val[1]).format('YYYY-MM-DD'),
    );
  }
  open(row: any) {
    console.log(row);
    this.shopData = row;
    this.title = '录音列表';
    this.form.shopId = row.shopId;
    this.shopId = row.shopId;
    this.getAudioList(this.form);
    this.visible = true;
  }

  showDrawer() {
    this.visible = true;
  }

  uploadAudio() {
    if (this.shopData.dyhStaffName) {
      this.audioShopUpload.open();
    } else {
      this.$message.warning('请先联系地推员认领');
    }
  }

  onSubmit() {
    this.getAudioList(this.form);
  }

  onReset() {
    this.form = {
      shopId: this.shopId,
      page: 1,
      pageSize: 10,
      name: '',
      pushed: '',
      username: '',
    };
    this.shopData = {};
    this.createTime = [];
    this.getAudioList(this.form);
  }

  async getAudioList(data: any) {
    const { page, pageSize, pushed, shopId, contact_time_start, contact_time_end, username } = data;
    const params: any = {
      page: page || 1,
      shop_id: shopId,
      pageSize: pageSize || 10,
    };
    if (pushed) {
      params.pushed = pushed;
    }
    if (contact_time_start) {
      params.contact_time_start = contact_time_start;
    }
    if (contact_time_end) {
      params.contact_time_end = contact_time_end;
    }
    if (username) {
      params.username = username;
    }
    const res = await this.brandService.brandAudioVoice(params) as any;
    console.log(res);
    this.dataSource = res.list;
    this.pagination.total = res.total;
  }

  async downloadAudio(url: any) {
    const fileName: any = getCurrentTimeSecond();
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(blobUrl);
  }

  onClose() {
    this.form = {
      shopId: this.shopId,
      page: 1,
      pageSize: 10,
      name: '',
      pushed: '',
      username: '',
    };
    this.visible = false;
    this.dataSource = [];
    this.pagination.total = 0;
    this.tabPane = '1';
    this.pagination.current = 1;
    this.pagination.pageSize = 10;
  }


  async pushAudio(row: any) {
    try {
      const res = await this.brandService.brandAudioPushVoice({
        voice_id: row.id,
      }) as any;
      if (res) {
        this.$message.success('操作成功');
        this.getAudioList(this.form);
      }
    } catch (error) {
      this.$message.error('操作失败');
    }
  }

  callback(info: any) {
    console.log(info);
    this.tabPane = info;
  }
}
